import styles from './Footer.module.css'

function Footer() {
  return (
    <footer className={styles.Footer}>
      <div>
        <ul>
          <li>
            Copyright &copy; 2023{' '}
            <a href="https://glebbahmutov.com/">Gleb Bahmutov</a>
          </li>
          <li>
            Learn more at <a href="https://cypress.tips">cypress.tips</a>
          </li>
        </ul>
      </div>
    </footer>
  )
}

export default Footer
